module.exports = __webpack_public_path__ + "static/fabulatorij-1ad87fa9b1e575961e43072e11a1c276.mp4";